<template>
  <div>
    <div>
    <b-nav class="main-nav">
    <b-nav-item class="logo">
    <img src="../assets/img/logo.png"/>
    </b-nav-item>
    <b-nav-item class="logout"
                               @click="dashboard()">
                               Dashboard
    </b-nav-item>
    <b-nav-item class="logout"
                               @click="support()">
                               Support
    </b-nav-item>
    </b-nav>
    </div>
      <div class = "profile-div col-12">
        <h5 class="mt-3 mb-3"> User Guide </h5>
        <br><br>
        <b-table  striped hover
                  :fields="fields"
                  :items="presentations">
          <template slot="link" slot-scope="data">
            <a :href='data.value' target="_blank"><v-icon name="download" base-class="icon-width"></v-icon></a>
          </template>
        </b-table>
        <br>
        <b-container class="bv-example-row">
          <b-row>
            <b-col lg="6">
              <b-embed
                type="iframe"
                aspect="16by9"
                src="https://www.youtube.com/embed/QOt-pt_boMg"
              ></b-embed>
              <br><br>
              <h6 style="text-align:center;"> Download & Activate License</h6><br><br><br>
            </b-col>
            <b-col lg="6">
              <b-embed
                type="iframe"
                aspect="16by9"
                src="https://www.youtube.com/embed/iP_0tvB8s-o"
              ></b-embed>
              <br><br>
              <h6 style="text-align:center;"> Add Camera & Setup Counting Zone</h6><br><br><br>
            </b-col>
          </b-row>
        </b-container>
      </div>
  </div>
</template>

<script>
import FacitHeader from '@/components/header';
import API from '@/api';

export default {
  name: 'userGuide',
  components: { FacitHeader },
  data() {
    return {
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      presentations: [],
      fields: [
        {
          key: 'name',
          label: 'Name',
          sortable: true,
        },
        {
          key: 'version',
          label: 'Version',
          sortable: true,
        },
        {
          key: 'link',
          label: 'Downloads',
          sortable: false,
        },
      ],
    };
  },
  created() {
    this.getApplications();
  },
  methods: {
    async getApplications() {
      const downloads = await API.get('Downloads');

      downloads.forEach(records => {
        if (records.type === 7) {
          this.presentations.push(records)
        }
      })
      this.totalRows = downloads.length;
    },
    dashboard() {
      this.$router.push('peoplecounting');
    },
    support() {
      this.$router.push('facitSupport');
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.icon-width {
  width: 20px !important;
  height: 20px !important;
}
.profile-div {
  margin-top: 50px;
  margin-left: 50px;
  width: 95% !important;
}
.main-nav {
  background-color: #2c3e50 !important;
  height: 90px;
  min-width: 100%;
  width: 100%;
}
.logo {
  margin-top: 20px;
  margin-left: 30px;
  width: 80%;
}
.logo2 {
  margin-top: 20px;
  margin-left: 30px;
  width: 55%;
}
.nav-link-custom {
    background: white;
    border: #fe5623;
    color: #656580 !important;
}
.logout {
  margin-top: 28px;
}
li > a > span{
  color: #656580 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/userGuide.vue